
import { useState, useEffect } from "react";
import { NavDropdown } from "react-bootstrap";

function NavHoverDropdown({ title, id, children }) {
    const [show, setShow] = useState(false);
    const [isDesktop, setIsDesktop] = useState(typeof window !== "undefined" ? window.innerWidth >= 992 : true);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleMouseEnter = () => isDesktop && setShow(true);
    const handleMouseLeave = () => isDesktop && setShow(false);
    const handleToggle = (isOpen) => !isDesktop && setShow(isOpen);

    return (
        <NavDropdown
            title={title}
            id={id}
            show={show}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            onToggle={handleToggle}
        >
            {children}
        </NavDropdown>
    );
}

export default NavHoverDropdown;
